import classes from './AccordionItem.module.scss';
import Markdown from 'markdown-to-jsx';
import { useState } from 'react';

export default function AccordionItem({ faqData }) {
    const [isOpen, setOpen] = useState(false);
    const isOpenState = isOpen ? `${classes['isOpen']} ${classes.mCaret}` : classes.mCaret;

    return (
        <div key={faqData.id} className={`${classes.accordionEntry}`}>
            <div className={`${classes.mTitle}`} onClick={() => setOpen(!isOpen)}>
                <h3 className={`${classes.aTitle} fnt-b fnt24f`}>{faqData.title}</h3>
                <div className={isOpenState}>
                    <svg
                        className={`${classes.aCaret}`}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M17 10L12 15L7 10"
                            stroke="#003D66"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>
            <div className={`${classes.mCopy} ${isOpenState} fnt16f`}>
                <Markdown>{faqData.copy}</Markdown>
            </div>
        </div>
    );
}
